import { render, staticRenderFns } from "./lp-campaign-for-investors-3.vue?vue&type=template&id=2d540a06&scoped=true"
import script from "./lp-campaign-for-investors-3.vue?vue&type=script&lang=js"
export * from "./lp-campaign-for-investors-3.vue?vue&type=script&lang=js"
import style0 from "./lp-campaign-for-investors-3.vue?vue&type=style&index=0&id=2d540a06&prod&scoped=true&lang=css"
import style1 from "./lp-campaign-for-investors-3.vue?vue&type=style&index=1&id=2d540a06&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d540a06",
  null
  
)

export default component.exports